<template>
  <div>
    <modal id="confirmationModal" class="confirmation-modal" :backdrop="false"  :width="localWidth"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header" v-if="textTitle && textTitle.length > 0">
        <h4 class="modal-title" :style="titleStyle">

          <strong>{{textTitle}}</strong>
        </h4>
      </div>
      <div  class="modal-body confirmation-modal-body " :style="'Width: '+model_height+'px;padding: 5px 15px; '" v-html="textMessage">
      </div>
      <div slot="modal-footer" class="modal-footer no_focus" style="background:white">
        <button v-if="textNo.length > 0" type="button" :class="'btn btn-default ' + no_color " @click="closed('no')">{{textNo}}</button>
        <button type="button" 
        :data-cy="'confirmation-modal-footer-yes-btn' + textTitle" 
        :class="'confirmation-modal-footer-yes-btn btn btn-' + yes_color " 
        id="confirmationModalYes" 
        v-show="textYes.length > 0"
        @click="closed('yes')">{{textYes}}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import  modal  from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:confirmation-modal");

export default {
  data() {
    return {
      show_modal: false,

      title_label: "",
      message: "",
      yes_label: "",
      no_label: "",
      callback:null,
      yes_color:"primary",
      no_color:"",
      model_height:"280",
      title_style : "",
      local_width:"325px" 
    };
  },
  computed: {
    localWidth:{
      get(){
        return this.local_width;
      },
      set(v){
        this.local_width = v;
      }
    },
    titleStyle:{
      get(){
        return this.title_style;
      },
      set(v){
        this.title_style = v;
      }
    },
      getTrue(){
          return true;
      },
      getFalse(){
          return false;
      },
    textTitle() {
      return this.title_label;
    },
    textMessage() {
      return this.message;// + uuid.v4();
    },
    textYes() {
      return this.yes_label;
    },
    textNo() {
      return this.no_label;
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    showModalWindow(data) {
      this.title_label = data.title;
      this.message = data.message;
      this.yes_label = data.yes_label;
      this.no_label = data.no_label;
      this.yes_color = data.yes_color || "primary";
      if(data.no_color){
        this.no_color = "btn-" + data.no_color;
      }
      this.model_height = data.model_height || "280"
      if((data.model_width||"").length >0){
        if(data.model_width.indexOf("px") > 0){
          this.localWidth = data.model_width
        }else{
          this.localWidth = data.model_width +"px";
        }
      }else{
        this.localWidth ="325px";
      }
      this.show_modal = true;
      this.titleStyle = data.title_style || "";

    },
    closed(mode) {
        console.log("mode",mode)
        this.show_modal = false;
        this.$emit('done',mode);
    }
  },
  props: {
    tag: { type: String, default: "showConfimationModal" }
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};
</script>
<style>

.no_focus::-moz-selection { /* Code for Firefox */
  background: white;
}

.no_focus::selection {
  background: white;
}
</style>
<style scoped>




.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// confirmation-modal.vue?5c04b4db